<script>
    import Axios from 'axios'
    import config from '../../../libs/config.js';
    import api from '../../../api'
    import { mapGetters, mapActions } from 'vuex'
    import _ from 'lodash'
    import _system from '../../../libs/system'	

    import { removeChannel } from '../mixins/removeChannel'

	export default 
	{
        name: 'accountsAppStore',
        mixins: [removeChannel],        
        data() 
        {
        	return {
                config: config,
                appUrl: '',
                pages: [],
                loader: true
        	}
        },
        computed: 
	    {
	        ...mapGetters('session', ['isLoggedIn','getUser', 'getRole','getJwt']),
            ...mapGetters('accounts', ['accounts']),
            ...mapGetters('tags', ['tagsByName']),        
            ...mapGetters('workspaceusers', ['workspaceusers']), 
            ...mapGetters('workspaces', ['currentWorkspace']),
	        ...mapGetters('networks', ['networks','networksByName'])
        },
        methods: {
            ...mapActions('accounts', ['setAccounts', 'removeChannel']),
            ...mapActions('networks', ['setNetworks']),
            reAuth(){
               document.getElementById("auth").submit(); 
            },            
            update_status(e, pageId){
                if(!e.target.checked) {
                    let payload = {
                        query: {
                            pageId: pageId
                        },
                        body: {
                            tagId: this.tagsByName['Passive']._id
                        }
                    }
                    _system.services.accounts.setTag(payload, (err, updatedChannel) => {
                        this.accounts[_.findIndex(this.accounts, { _id: pageId })] = updatedChannel
                    });                   
                }else{
                    console.log('aga')
                    let payload = {
                        query: {
                            pageId: pageId,
                            tagId: this.tagsByName['Passive']._id
                        }
                    }
                    _system.services.accounts.deleteTag(payload, (err, updatedChannel) => {
                        this.accounts[_.findIndex(this.accounts, { _id: pageId })] = updatedChannel
                    });
                }

            }              
        },
        mounted(){
            $('.ui.dropdown').dropdown({
                transition: 'scale'
              })
        },
        created(){
            //Store Fetching
            if(this.accounts && this.networks){
                this.pages = _.filter(this.accounts, (e) => { return e.platform == this.networksByName['App Store']._id }); 
                this.loader = false;
            }  

            //API Fetching
/*             if(!this.accounts){
                        api.get('/api/v1/platforms', (err, data) => {
                if(err) return console.log(err);
                    this.setNetworks(data);

                api.get('/api/v1/workspaces?user=' + this.getUser._id, (err, data) => {
                    if(err) return console.log(err);
                        this.setAccounts(_.get(data, '[0].pages', []));

                let youtubeId = _.find(this.networks, function(e){ return e.name == 'Youtube' })._id
                this.pages = _.filter(this.accounts, function(e){ return e.platform == youtubeId }); 
                this.pages = _.map(this.pages, page => {
                    if(!page.name) page.name = page.screenName;
                    return page
                })
                this.loader = false;
                });
                });
            } */
        }
	}
</script>

<template>
	<span>

    <div style="background: #f5f5f5; margin-bottom: 1rem;" class="ui grid">
        <div class="sixteen wide column">
        <form v-if="getRole.name == 'Admin'" id="auth" class="ui fluid form center aligned action" :action=" config.url + '/appstore/redirect'" method="get">
        <input type="text" name="state" :value="JSON.stringify({'userId':getUser._id,'workspaceId': currentWorkspace._id, 'appUrl': appUrl })" hidden>
        <div class="field">
        <input style="display: inline-block;" name="appUrl" v-model="appUrl" type="text" placeholder="Copy and paste your AppStore URL ex: https://apps.apple.com/us/app/juphy/id1521931617">
        </div>
        <div class="field">
        <button  type="submit" value="Submit" class="ui fluid button" :disabled="(appUrl.length < 4)">Connect </button>
        </div>
        </form>
        </div>
        </div>

        <div v-if="!loader && !pages.length" class="ui basic padded segment center aligned">
            <p style="color: #ccc;font-size: 20px;font-style: italic;">
                Don't have any active AppStore Application
            </p>
        </div>

        <table v-if="!loader && pages.length" style="padding: 0rem 0.5rem;" class="ui very basic celled table fluid">
            <tbody>
            
            <tr v-for="account in pages" :key="account._id">
                <td><h4 class="ui image header">
                    <img :src="account.avatar" class="ui mini rounded image">
                    <div class="content">
                        {{account.name}}

                    </div>
                </h4></td>
<!--                               <td class="collapsing">
                    <a class="ui basic label">#tw-{{account.screenName}}</a>
                </td> -->
                <td class="collapsing" style="vertical-align: bottom;">



                <div  v-if="account.tags && account.tags.indexOf('5e8e0527817d3903cb610bde') != -1" class="ui compact warning small message" style="width:400px;">
                        <div class="header">Permissions Expired</div>
                        <p>Juphy can't access data for this channel. To regain data access, you have to re-authorize your account's permissions. 
                            <a :href="'#'" @click="reAuth()">Click here to re-authorize</a>
                        </p>
                    </div>


<!--                     <div v-if="getRole.name == 'Admin' && (account.tags && account.tags.indexOf('5e8e0527817d3903cb610bde') == -1) || (!account.tags)" class="ui fitted toggle checkbox check">
                        
                        <input v-if="account.tags && account.tags.indexOf(tagsByName['Passive']._id) != -1"  @click="update_status($event, account._id)" type="checkbox" :checked="false">
                        <input v-if="!account.tags || account.tags.indexOf(tagsByName['Passive']._id) == -1" @click="update_status($event, account._id)" type="checkbox" :checked="true"> 
                        <label></label>
                        
                    </div> -->
                </td>
            <td class="collapsing">
                <div style="background: transparent;" class="ui left dropdown icon button">
                    <i class="ellipsis vertical icon"></i>
                    <div class="menu">
                        <div @click="deleteChannel(account._id)" class="item">
                        Delete
                        </div>
                    </div>
                    </div>
                </td>
<!--                               <td class="collapsing">
                    <a :href="'/account/settings/'+ account.id" class="ui basic small icon button more-basic"><i class="cog icon"></i></a>
                </td> -->
            </tr>
            
            </tbody>
        </table> 
	</span>
</template>


<style scoped >
.ui.table thead th {
    border-bottom: none;
}
.ui.toggle.checkbox input:checked ~ label::before {
    background-color: #8ef2b6 !important;
}
.ui.toggle.checkbox label::before{
    height: 1.9rem;
}
.ui.toggle.checkbox label::after{
    height: 1.9rem;
    width: 1.9rem;
}
.ui.toggle.checkbox input:checked ~ label::after {
    left: 1.6rem;
    box-shadow: 1px 1px 1px #ddd;
}
.ui.toggle.checkbox input {
    height: 1.9rem;
}
.ui.table td.collapsing, .ui.table th.collapsing {
    width: 1px;
    white-space: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/dashboard/accounts/appStore.vue